'use client';

import Link from 'next/link';
import { CheckCircle, XCircle } from 'phosphor-icons';
import { useState } from 'react';
import { c } from '../../../utils/tailwind-merge';
import { ButtonV2 } from '../../atoms/Button/Button.v2';
import { RichText } from '../RichText';
import { WriteReviewTipsProps } from './WriteReviewTips.types';

export const WriteReviewTips = ({
  title,
  doTip,
  dontTip,
  cta,
  expand,
  onEmailPublisher,
  className,
}: WriteReviewTipsProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const renderDontTips = (
    <div>
      <h3 className="mb-2 flex items-center">
        <XCircle size={24} weight="bold" className="mr-4" />
        <span className="text-md font-medium"> {dontTip.title}</span>
      </h3>
      <RichText
        html={dontTip.content}
        className="mb-5 block text-content-muted [&_li]:mx-0 [&_li]:my-2 [&_li]:list-none"
      />
    </div>
  );

  const renderButtonPrimaryAction = (
    <ButtonV2
      onClick={onEmailPublisher}
      label={cta}
      variant="secondary-black-monochrome"
      shape="square"
      size="medium"
      data-testid="write-review-tips"
      data-test="write-review-tips"
    />
  );

  return (
    <div className={c('text-content-muted', className)}>
      <h2 className="mb-5 text-sm">{title}</h2>
      <div>
        <h3
          className={c(
            'flex items-center md:mb-2',
            !isExpanded ? 'mb-5' : 'mb-2'
          )}
        >
          <CheckCircle size={24} weight="bold" className="mr-4" />
          <span className="text-md font-medium"> {doTip.title}</span>
        </h3>
        <RichText
          html={doTip.content}
          className="mb-5 block text-content-muted [&_li]:mx-0 [&_li]:my-2 [&_li]:list-none"
        />
      </div>
      <div className="block md:hidden">
        {!isExpanded && (
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              toggleExpand();
            }}
            className="text-small text-link"
          >
            {expand}
          </Link>
        )}

        {isExpanded && (
          <>
            {renderDontTips}
            {renderButtonPrimaryAction}
          </>
        )}
      </div>
      <div className="hidden md:block">
        {renderDontTips}
        {renderButtonPrimaryAction}
      </div>
    </div>
  );
};
